import React from 'react';
import parse from 'html-react-parser';
import { IconArrowRight, IconNotification, IconClose } from '../Icons/Icons';
import { BASE_URL } from '@fci/business-layer/constants';
import { settingConfiguration } from '@fci/business-layer/storage';

const HomeActivePopups = ({ activePopups, showPopupList, canClosePopup, setShowPopupList, setActivePopups }) => {
    console.log('BASE_URL', settingConfiguration.get(BASE_URL))
    const hasUnreadPopups = activePopups.length > 0;
    const onOpen = () => setShowPopupList(true);
    const onClose = () => {
        onDismissAll();
    };
    const onDismissAll = () => {
        if (!canClosePopup) return;
        setActivePopups([]);
        setShowPopupList(false);
    };
    const onDismissItem = (popupId) => {
        if (!canClosePopup) return;
        setActivePopups((prev) => {
            const next = prev.filter((popup) => popup?.id !== popupId);
            if (next.length === 0) {
                setShowPopupList(false);
            }
            return next;
        });
    };

    if (!hasUnreadPopups) {
        return null;
    }

    function convertEntityUrl(input) {
        if (!input || typeof input !== 'string') return null;

        // Check if it's already a full URL
        if (/^(https?|mailto|tel):/i.test(input)) {
            return input;
        }

        let path = input;
        // Handle legacy entity format
        if (path.startsWith('entity:')) {
            path = path.replace('entity:', '');
        }

        // Remove leading slash if any
        if (path.startsWith('/')) {
            path = path.substring(1);
        }

        const baseUrl = settingConfiguration.get(BASE_URL) || '';
        const separator = baseUrl.endsWith('/') ? '' : '/';
        return `${baseUrl}${separator}${path}`;
    }

    return (
        <>
            {!showPopupList && (
                <div
                    role="alert"
                    aria-label={`You have ${activePopups.length} notification${activePopups.length > 1 ? 's' : ''}`}
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        pointerEvents: 'auto',
                        animation: 'slideUpFade 280ms ease-out',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <style>{`
                        @keyframes slideUpFade {
                            from { transform: translateY(100%); opacity: 0; }
                            to   { transform: translateY(0);    opacity: 1; }
                        }
                    `}</style>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px 16px 0 0',
                            boxShadow: '0px -4px 12px rgba(0, 0, 0, 0.1)',
                            padding: '12px 16px',
                            minHeight: '64px',
                            width: '100%',
                            maxWidth: '760px',
                            margin: '0 auto',
                            cursor: 'pointer',
                        }}
                        onClick={onOpen}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                            <IconNotification className="text-blue" style={{ width: '22px', height: '22px', flexShrink: 0 }} />
                            <span className="text-blue" style={{ fontSize: '14px', fontWeight: 600, lineHeight: 1.3 }}>
                                You have{' '}
                                <span className='text-violet'>
                                    {activePopups.length} notification{activePopups.length > 1 ? 's' : ''}
                                </span>
                            </span>
                        </div>
                        <button
                            type="button"
                            aria-label="View notifications"
                            className='bg-blue'
                            style={{
                                width: '60px',
                                height: '36px',
                                borderRadius: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                flexShrink: 0,
                            }}
                            onClick={(e) => { e.stopPropagation(); onOpen(); }}
                        >
                            <IconArrowRight style={{ width: '16px', height: '16px', color: '#FFFFFF' }} />
                        </button>
                    </div>
                </div>
            )}

            {showPopupList && (
                <div
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        pointerEvents: 'auto',
                        animation: 'slideUpFade 280ms ease-out',
                    }}
                >
                    <style>{`
                        @keyframes slideUpFade {
                            from { transform: translateY(100%); opacity: 0; }
                            to   { transform: translateY(0);    opacity: 1; }
                        }
                    `}</style>
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '760px',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px 16px 0 0',
                            boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
                            overflow: 'hidden',
                            maxHeight: '70vh',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '14px 16px',
                                borderBottom: '1px solid #E8EDF5',
                                flexShrink: 0,
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                                <IconNotification className="text-violet" />
                                <span className='text-blue' style={{ fontSize: '15px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                                    Notifications
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                                {canClosePopup && (
                                    <button
                                        type="button"
                                        className='text-blue border-blue'
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: '1px solid #225185',
                                            borderRadius: '20px',
                                            padding: '5px 13px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            height: '36px'
                                        }}
                                        onClick={onDismissAll}
                                    >
                                        Dismiss all
                                    </button>
                                )}
                                {canClosePopup && (
                                    <button
                                        type="button"
                                        aria-label="Close notifications"
                                        className='bg-blue'
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                        }}
                                        onClick={onClose}
                                    >
                                        <IconClose className="text-white" style={{ width: '14px', height: '14px', color: '#FFFFFF' }} />
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* List */}
                        <div style={{ overflowY: 'auto', flex: 1, padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '0' }}>
                            {activePopups.map((popup) => (
                                <article
                                    key={`${popup.id}`}
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        borderBottom: '1px solid #E8EDF5',
                                        padding: '14px 0',
                                    }}
                                >
                                    <h4 className='text-violet' style={{ fontSize: '14px', fontWeight: 700, margin: '0 0 8px 0' }}>
                                        {popup.title}
                                    </h4>
                                    <div style={{ fontSize: '13px', color: '#5C6065', lineHeight: 1.5, marginBottom: '12px' }}>
                                        {parse(popup?.body ?? '')}
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                        {popup?.ctaText && popup?.ctaLink ? (
                                            <a
                                                href={convertEntityUrl(popup.ctaLink) ?? popup.ctaLink}
                                                className='bg-violet text-white'
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: 'inline-block',
                                                    borderRadius: '4px',
                                                    padding: '7px 16px',
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                {popup.ctaText}
                                            </a>
                                        ) : <div />}
                                        {canClosePopup && (
                                            <button
                                                type="button"
                                                className='text-blue'
                                                style={{ background: 'none', border: 'none', fontSize: '13px', fontWeight: 600, cursor: 'pointer', padding: '8px 0 8px 12px', textDecoration: 'underline' }}
                                                onClick={() => onDismissItem(popup.id)}
                                            >
                                                Dismiss
                                            </button>
                                        )}
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HomeActivePopups;
